import * as React from 'react'

import { useCopy } from '@owl-nest/copier'
import * as hooks from '@owl-nest/hooks'
import * as ds from '@bob/design-system'
import { styles as S } from '@bob/design-system'

export function SocialShare({
  column = false,
  buttonLabel = 'Partager',
  url,
  title,
  text,
}: {
  buttonLabel?: string
  url: string
  title: string
  text: string
} & S.socialShare.SocialShareProps): React.ReactElement {
  const { canCopy, copy, copyStatus } = useCopy(4000)
  const { canNativelyShare, share } = hooks.useSocialShare()
  const isClientSide = hooks.useClientSide()

  if (isClientSide && canNativelyShare && !column && ds.utils.browser.isMobile()) {
    return (
      <ds.Button
        onClick={() =>
          share({
            url,
            title,
            text,
          })
        }
      >
        {buttonLabel}
      </ds.Button>
    )
  }

  return (
    <ds.SocialShare
      copyStatus={copyStatus}
      column={column}
      onShare={(socialMedia) =>
        socialMedia === 'share'
          ? canCopy && copy(url)
          : share({
              classic: column ? true : !(isClientSide && ds.utils.browser.isMobile() && canNativelyShare),
              socialMedia,
              title,
              text,
              url,
            })
      }
    />
  )
}
